import { Pipe, PipeTransform } from '@angular/core';

import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import {
  MULTIPLE_CARRIERS_IMG,
  MULTIPLE_CARRIERS, DISABLED
} from '@shared/widgets/components/flights-widget/flights-widget.constants';

@Pipe({
  name: 'airlineImage',
  standalone: false
})
export class AirlineImagePipe implements PipeTransform {

  constructor(private imgCdn: ImageCdnPipe) { }

  transform(code: string, isDisabled: boolean = false): string {
    code = code === MULTIPLE_CARRIERS ? MULTIPLE_CARRIERS_IMG : code;
    code = isDisabled ? `${code}_${DISABLED}` : code;
    return code ? this.imgCdn.baseImage(`${code}.png`, 'web/travel/airlines') : '';
  }
}
